// extracted by mini-css-extract-plugin
export default {"fieldNoteSection":"ManageCreditNote_fieldNoteSection__V3VQP","fieldNoteEach":"ManageCreditNote_fieldNoteEach__zJRS8"};